import '../Banner.scss';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setActiveDrawer } from '../../../actions/lister-actions';
import LG_BANNER_CONTENT from './LgBanner.json';

const BrandedBanner = () => {
	const dispatch = useDispatch();

	const { canonical } = useSelector((state) => state);

	const content = LG_BANNER_CONTENT.find(({ categories }) =>
		categories.find((category) => canonical.includes(category))
	);

	if (!content) {
		return null;
	}

	const { brand, desktop, mobile, category, altText } = content;

	const bannersFolder =
		'https://media.ao.com/lister/assets/images/branded-drawer/banners/';

	return (
		<button
			type="button"
			className="banner__button w-full p-0 rounded-none md:rounded-lg"
			data-testid="branded-drawer-banner"
			data-tag-section="lister banner"
			data-tag-name={`${brand} ${category} Banner`}
			data-tag-type="banner"
			onClick={() => dispatch(setActiveDrawer('branded', { brand }))}>
			<picture>
				<source
					srcSet={`${bannersFolder}${desktop.src}`}
					media="(min-width: 768px)"
					type="image/webp"
				/>
				<source
					srcSet={`${bannersFolder}${desktop.fallback}`}
					media="(min-width: 768px)"
				/>
				<source srcSet={`${bannersFolder}${mobile.src}`} type="image/webp" />
				<img
					className="w-full md:rounded"
					src={`${bannersFolder}${mobile.fallback}`}
					alt={altText}
				/>
			</picture>
		</button>
	);
};

export default BrandedBanner;
